import { FinanceProvider } from '@kanda-libs/ks-frontend-services';

export const BASE_TERMS =
  'I understand that Ideal4Finance may be paid a commission for introducing me to {{provider}}.{{disclaimer}} The amount of commission is pre agreed between {{provider}} and Ideal4Finance and is a percentage of the amount of credit. {{provider}} will make the commission payment to Ideal4Finance once the goods have been installed. By signing this document, I consent to the commission payment being made to Ideal4Finance as part of this agreement.';

export const PROVIDERS: Record<FinanceProvider, string> = {
  omni: 'Omni Capital Retail Finance',
  allium: 'Tandem Bank',
  propensio: 'Propensio Finance Limited',
  etika: 'Etika Finance UK Limited',
  humm: 'Humm Group Limited',
  novuna: 'Novuna Finance',
  demo: 'Ideal4Finance',
};

export const HUMM_DISCLAIMER =
  ' Ideal4Finance is a non-exclusive credit broker for humm, and we will introduce you to humm for your selected rate before introducing you to any other lender.';
